import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ExhibitionIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ExhibitionIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.8282 5.60122C9.99932 5.54565 10.1819 5.51563 10.3716 5.51563H11.2668C12.1284 5.51563 12.9781 5.31503 13.7488 4.92975M9.8282 5.60122C10.0656 4.22155 11.2679 3.17187 12.7153 3.17187C14.1628 3.17187 15.365 4.22155 15.6025 5.60122C15.5809 5.59423 15.5593 5.58765 15.5374 5.58148C15.4326 5.33918 15.2553 5.1302 15.0236 4.98703L15.0236 4.98701C14.6374 4.74839 14.1551 4.72655 13.7489 4.9297M15.645 7.27344C15.645 7.59701 15.3827 7.85938 15.0591 7.85938C14.7355 7.85938 14.4731 8.12171 14.4731 8.44531C14.4731 9.41612 13.6861 10.2031 12.7153 10.2031C11.7445 10.2031 10.9575 9.41612 10.9575 8.44531C10.9575 8.12171 10.6952 7.85938 10.3716 7.85938C10.048 7.85938 9.78564 7.59701 9.78564 7.27344C9.78564 6.94982 10.048 6.6875 10.3716 6.6875H11.2668C12.3104 6.6875 13.3396 6.44452 14.2729 5.97788L14.273 5.97783C14.3158 5.95643 14.3667 5.95866 14.4076 5.9839M15.645 7.27344C15.645 6.94982 15.3827 6.6875 15.0591 6.6875C14.7355 6.6875 14.4731 6.42517 14.4731 6.10156C14.4731 6.0536 14.4483 6.00911 14.4076 5.98393M16.8169 7.27344C16.8169 8.05455 16.3074 8.71675 15.6025 8.94565C15.4732 9.69666 15.0581 10.3499 14.4731 10.7893V11.375H15.0591C17.3327 11.375 19.1606 13.2589 19.1606 15.5156C19.1606 15.8392 18.8983 16.1016 18.5747 16.1016C17.1634 16.1016 15.9747 17.1335 15.7032 18.484H17.403C17.7266 18.484 17.9889 18.7464 17.9889 19.07V21.4137C17.9889 21.7373 17.7266 21.9997 17.403 21.9997H8.02798C7.70438 21.9997 7.44205 21.7373 7.44205 21.4137V19.07C7.44205 18.7464 7.70438 18.484 8.02798 18.484H9.72745C9.45596 17.1335 8.26728 16.1016 6.85596 16.1016C6.53235 16.1016 6.27002 15.8392 6.27002 15.5156C6.27002 13.2589 8.09795 11.375 10.3716 11.375H10.9575V10.7893C10.3726 10.3499 9.95743 9.69666 9.8282 8.94565C9.12331 8.71675 8.61377 8.05455 8.61377 7.27344V6.10156C8.61377 3.83632 10.4501 2 12.7153 2C14.9805 2 16.8169 3.83631 16.8169 6.10156V7.27344ZM12.1294 11.3164V11.9609C12.1294 12.2845 11.8671 12.5469 11.5435 12.5469H10.3716C8.94289 12.5469 7.74235 13.6043 7.49048 14.9794C9.2687 15.2606 10.6618 16.7035 10.916 18.484H14.5147C14.7689 16.7035 16.162 15.2606 17.9402 14.9794C17.6883 13.6043 16.4878 12.5469 15.0591 12.5469H13.8872C13.5636 12.5469 13.3013 12.2845 13.3013 11.9609V11.3164C13.1119 11.3548 12.916 11.375 12.7153 11.375C12.5147 11.375 12.3187 11.3548 12.1294 11.3164ZM10.3516 19.6559H8.61392V20.8278H16.817V19.6559H15.0791C15.0725 19.6561 15.0658 19.6562 15.0591 19.6562H10.3716C10.3649 19.6562 10.3582 19.6561 10.3516 19.6559Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ExhibitionIcon;
